import { fetchUtils } from '../utils/fetchUtils';

export const authService = {
  // Login
  login: async (email, password) => {
    const res = await fetchUtils.post('/api/auth/login', { email, password });
    return res; // returns { success, message, user, token }
  },

  // Register
  register: async (data) => {
    return fetchUtils.post('/api/auth/register', data);
  },

  // Get logged-in user details
  getUserDetails: async () => {
    return fetchUtils.get('/api/user');
  },

  // Update user
  updateUser: async (data) => {
    return fetchUtils.post('/api/user', data);
  },

  // Logout
  logout: async () => {
    return fetchUtils.get('/api/user/logout');
  },
};
